// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"55099aba","311":"55099aba"}[chunkId] + ".chunk.css";
};